import { useRef } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { useTimeout } from '@/ui/hooks/useTimeout';
import { ANIMATION_DURATION } from '@/ui/lib/constants';
import { Logo } from './Logo/Logo';
import { Guide } from './Guide/Guide';
import LandingBacgroundImage from '@/assets/images/landing-bg.webp';
import './landing.css';

const SHOW_LOGO_TIMEOUT = 2000;

interface LandingProps {
    startGame: () => void;
}

export const Landing = ({ startGame }: LandingProps) => {
    const transitionRef = useRef<HTMLDivElement>(null);
    const elapsed = useTimeout(SHOW_LOGO_TIMEOUT);

    return (
        <div
            className="landing"
            style={
                {
                    '--background-image': `url(${LandingBacgroundImage})`,
                } as React.CSSProperties
            }
        >
            <SwitchTransition>
                <CSSTransition
                    key={!elapsed ? 'logo' : 'guide'}
                    nodeRef={transitionRef}
                    timeout={ANIMATION_DURATION}
                    unmountOnExit
                    classNames="fade"
                >
                    <main className="landing__route" ref={transitionRef}>
                        {!elapsed ? <Logo /> : <Guide startGame={startGame} />}
                    </main>
                </CSSTransition>
            </SwitchTransition>
        </div>
    );
};
